/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */

import React, { FC, useMemo } from 'react';
import { ReactComponent as NotificationSvg } from 'assets/noti.svg';
import TooltipPoratal from 'components/UI/TooltipPoratal';
import { Trans } from 'react-i18next';
import moment from 'moment';
import {
  isMassCreativeCreateMessage,
  isScreenshotMessage,
} from 'domains/notification/types';
import PackageUploadModal from 'domains/creative/creatives/components/PackageUploadModal';
import { Link } from 'react-router-dom';
import css from './styles.module.scss';
import Panel from './Panel';
import { IFormattedNotification } from './types';
import { useNotificationPanel } from './hooks/useNotificationPanel';

const NotificationPanel: FC = () => {
  const {
    t,
    notificationMessages,
    open,
    setOpen,
    buttonRef,
    markAllAsRead,
    markAsRead,
    markAsReadAndRemove,
    unreadCount,
    handleGetTask,
    openTaskModal,
    setOpenTaskModal,
  } = useNotificationPanel();

  const formattedNotifications: IFormattedNotification[] =
    useMemo(
      () =>
        notificationMessages?.map((item) => ({
          ...item,
          text: (
            <Trans
              key={item.notification_id}
              i18nKey={
                ['SUCCESS'].includes(item.message.status)
                  ? 'notification_success'
                  : 'notification_error'
              }
              values={{
                // eslint-disable-next-line no-nested-ternary
                name: isMassCreativeCreateMessage(item.message)
                  ? `[${item.message.campaign_internal_id}] ${item.message.campaign_title}`
                  : isScreenshotMessage(item.message)
                  ? `${item.message.creative_xxhash} ${item.message.creative_title}`
                  : '',
              }}
              components={{
                a: (
                  <Link
                    to={`/main/campaign/${item.message.campaign_xxhash}/creatives`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      e.stopPropagation();
                      markAsRead(item.notification_id);
                    }}
                  />
                ),
              }}
            />
          ),
        })),
      [notificationMessages],
    ) || [];

  const sortedNotifications = useMemo(
    () =>
      [...(formattedNotifications || [])].sort(
        (a, b) =>
          moment(b.date, ['DD.MM.YYYY  HH:mm', 'YYYY-MM-DD HH:mm:ss']).valueOf() -
          moment(a.date, ['DD.MM.YYYY  HH:mm', 'YYYY-MM-DD HH:mm:ss']).valueOf(),
      ),
    [formattedNotifications],
  );

  return (
    <div className={css.notification}>
      <div
        className={css.notification__main}
        onClick={() => setOpen(!open)}
        ref={buttonRef}
      >
        <TooltipPoratal
          hint={t(`notifications_title`)}
          white
          bottomRight
          hideHint={open}
        >
          <NotificationSvg />
        </TooltipPoratal>

        {unreadCount > 0 && (
          <div className={css.notification__count}>{unreadCount}</div>
        )}
      </div>
      <Panel
        open={open}
        anchorRef={buttonRef}
        onClose={() => setOpen(false)}
        buttonRef={buttonRef}
        notificationsList={sortedNotifications}
        markAsRead={markAsRead}
        markAsReadAndRemove={markAsReadAndRemove}
        markAllAsRead={markAllAsRead}
        handleGetTask={handleGetTask}
      />
      {openTaskModal && (
        <PackageUploadModal
          onCloseModal={() => setOpenTaskModal(false)}
          clickOutside
        />
      )}
    </div>
  );
};

export default NotificationPanel;
